import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme, noBg, noHeading }) => ({
    margin: toRem(20),

    '& .ServicesContainer': {
        maxWidth: noHeading ? 1320 : 1440,
        margin: 'auto',
        padding: toRems([10, 20, 20]),
        background: noBg ? null : theme.colors.blueLight,
        borderRadius: 4,

        [theme.breakpoints.up('md')]: {
            padding: noHeading ? null : toRems([70, 80])
        },

        [theme.breakpoints.up('lg')]: {
            padding: noHeading ? toRems([70, 20]) : null
        },

        '& .Heading': {
            marginBottom: toRem(45),
            '& .Title': {
                color: theme.colors.goldDark,
                fontSize: toRem(20),

                [theme.breakpoints.up('lg')]: {
                    fontSize: toRem(24),
                    fontWeight: '500'
                }
            },

            '& .Subtitle': {
                fontSize: toRem(14),
                [theme.breakpoints.up('lg')]: {
                    fontSize: toRem(20)
                }
            },
            [theme.breakpoints.up('lg')]: {
                marginBottom: toRem(20)
            }
        },

        '& .Content': {
            [theme.breakpoints.up('lg')]: {
                display: 'flex',
                flexDirection: "column",
                alignItems: noHeading ? 'flex-start' : 'center',
                justifyContent: 'space-between'
            },

            '& .Text': {
                fontSize: toRem(14),
                display: noHeading ? 'none' : 'block',

                [theme.breakpoints.up('lg')]: {
                    display: noHeading ? 'block' : 'block',
                    //maxWidth: noHeading ? 280 : 400,
                    //width: '80%',
                    fontSize: toRem(20)
                }
            },
            '& .ServicesList': {
                display: 'flex',
                flexWrap: 'wrap',
                listStyle: 'none',
                marginTop: toRem(40),
                li: {
                    width: '100%',
                    [theme.breakpoints.up('lg')]: {
                        width: '50%'
                    }
                },
                [theme.breakpoints.up('lg')]: {
                    marginTop: 0,
                    width: '100%'
                }
            }
        },
        '& .CtaContainer': {
            textAlign: 'center',
            padding: toRems([15, 0, 20, 0]),
            [theme.breakpoints.up('lg')]: {
                padding: toRems([45, 0, 20, 0])
            },
            '& a': {
                '& > span': {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    '& svg': {
                        display: 'block',
                        flexShrink: 0,
                        marginLeft: toRem(5)
                    }
                }
            }
        }
    }
})

export default style
